/**
 * Max lengths for transfer bond request free-text fields.
 * Mirror the DB columns (TransferBondCourtInfo / TransferBondOnlineDetails) and the
 * backend CreateTbondRequest.Validate() checks — change all three together.
 */
export const REQUEST_FIELD_MAX_LENGTH = {
  submittedBy: 100,
  jail: 255,
  court: 80,
  defendantFirstName: 20,
  defendantLastName: 20,
};

/**
 * Max lengths for Accept Quote free-text fields, keyed by AcceptQuoteModal formState /
 * power field name. Mirror TransferBondCourtInfo / Address columns and the backend
 * SelectQuoteRequest.Validate() checks. Phone and SSN inputs already cap at 10/9 digits.
 */
export const ACCEPT_QUOTE_FIELD_MAX_LENGTH = {
  firstName: 20,
  middleInitial: 1,
  lastName: 20,
  bookingNumber: 25,
  driversLicenseNumber: 25,
  race: 20,
  jailInfo: 255,
  defendantStreet: 80,
  defendantCity: 25,
  defendantZipCode: 5,
  hairColor: 20,
  eyeColor: 20,
  xrefNumber: 25,
  pfnNumber: 25,
  nearestRelativeName: 50,
  nearestRelativeAddressStreet1: 80,
  nearestRelativeAddressStreet2: 80,
  nearestRelativeAddressCity: 25,
  nearestRelativeAddressZipCode: 5,
  nextOfKinName: 50,
  nextOfKinAddressStreet1: 80,
  nextOfKinAddressStreet2: 80,
  nextOfKinAddressCity: 25,
  nextOfKinAddressZipCode: 5,
  offense: 255,
  offenseType: 25,
  caseNumber: 25,
  courtPlace: 80,
};
